import artikelauswahlClient from "@/legacy/artikelauswahlClient";
import { artikelauswahlSettings, getArtikelNrOhneEigentuemer } from "@/lib/artikelauswahl";
import { mountCaptchaInForm } from "@/lib/captcha";
import { saveWebCookie, webCookie } from "@/lib/cookies";
import { dataLayerPush } from "@/lib/dataLayer";
import { getAuthenticationTicket, setAuthenticationTicket } from "@/lib/formsAuthentication";
import type { ApiStatusResult } from "@/lib/models/api";
import type { ArtikelauswahlApiResponse } from "@/lib/models/artikelauswahl";
import { NotificationStyle } from "@/lib/models/notifications";
import { WarenkorbTyp } from "@/lib/models/warenkorb";
import { getNotificationStatus, showNotification } from "@/lib/notifications";
import { apiEndpoints, environment } from "@/lib/resources";
import { getInputUndLabel, replaceHash } from "@/lib/util";
import { addToWarenkorb } from "@/lib/warenkorb";
import { Cadenas3DViewer } from "@/ui/normblatt/3dViewer";
import { setLagerverfuegbarkeitsFarbe } from "@/ui/normblatt/lagerVerfuegbarkeit";
import { showStepDownload } from "@/ui/normblatt/stepDownload";
import { updateWarenkoerbeInfos } from "@/ui/warenkorb/updateWarenkoerbeInfos";
import { StatusCodes } from "http-status-codes";
import $ from "jquery";

const $artikelauswahl = $("#product-dimensions");

/** Kann mit Spread Operator (...) zum Header Object von Requests hinzugefügt werden */
const landKuerzelHeader = { [environment.landKuerzelHeaderName]: environment.landKuerzel };

const $artikelauswahlEigenschaften = $artikelauswahl.find(".artikelauswahl-eigenschaften");
const $artikelauswahlEigenschaftenModal = $artikelauswahl.find(".artikelauswahl-eigenschaften-modal");
const $artikelNr = $artikelauswahl.find("#artikelnr");
// Existiert nur bei Inocon
const $microDataArtikelNr = $artikelauswahl.find("#microDataArtikelNr");
const $cadenas3DButton = $("#cadenas3dbutton");
const $cadenas3DButtonWrapper = $("#product-3d-preview");
const artikelBestellen = $artikelauswahl.find(".product-purchase");
const artikelCad = $artikelauswahl.find(".product-cad");

const $artikelPreisInfo = $artikelauswahl.find(".product-purchase__price");
const $artikelZusatzInfo = $artikelauswahl.find("#zusatz-info");
const $artikelLagerverfuegbarkeitInfo = $artikelauswahl.find(".product-availability");
const $artikelMenge = $artikelauswahl.find("#product-count");
const $artikelLocationData = $artikelauswahl.find("#product-location-data");

const $cadArtikelnummerFelder = $artikelauswahl.find(':hidden[name="Artikelnummer"]');

const $cadDownloadTitel = $artikelauswahl.find("#cad-download-titel");
const $cadDownloadForm = $artikelauswahl.find("#cad-download");
const $cadDownloadForms = $artikelauswahl.find(".download_form");

const $cadAnfrageTitel = $artikelauswahl.find("#cad-anfrage-titel");
const $cadAnmeldenForm = $artikelauswahl.find("#cad-anmelden");

const $cadSchnellAnmeldenForm = $artikelauswahl.find<HTMLFormElement>("#cad-schnell-anmelden");
const cadSchnellAnmeldenCaptcha = $cadSchnellAnmeldenForm.map((_, el) => mountCaptchaInForm(el))[0];

const $cadAnfrageForm = $artikelauswahl.find<HTMLFormElement>("#cad-anfrage");
const $alsFavoritSpeichern = $artikelauswahl.find(".product-remember");
const $alsMerklisteSpeichern = $artikelauswahl.find("#product-to-shopping-list");
const $alsMerklisteAnlegen = $artikelauswahl.find("#create-shopping-list");
const cadAnfrageCaptcha = $cadAnfrageForm.map((_, el) => mountCaptchaInForm(el))[0];

const $cadStdButton = $artikelauswahl.find("#cad_std_button");
const $cadAngemeldetAlsEmailButton = $artikelauswahl.find("#cad_angemeldet_email_button");
const $cadFreierDownloadButton = $artikelauswahl.find("#cad_free_download_button");

const konfigurator3DViewer = new Cadenas3DViewer($(".component_container")[0]!);
konfigurator3DViewer.setArtikel({
	projektdatei: $cadenas3DButton.attr("data-projektdatei") as string,
	artikelnummer: $cadenas3DButton.attr("data-artikelnr") as string,
});

konfigurator3DViewer.onVariableChanged.add(([_, __, table]) => {
	// ArtikelNummer von varset abholen
	const match = table.mident.match(/\{PARTNUMBER=(.*?)\}/);
	if (match && match.length >= 2) {
		updateArtikelauswahlVia3DPreview(match[1]!);
	}
});

//Mit den Zusatzinfos muss hier ziemlich getrickst werden.
//Die Inhalte werden bei jeder Artikelauswahl im DOM neu gesetzt.
//Die statischen EventHandler des Toggle-Modules von re-Lounge ist somit nicht mehr funktionsfähig.
//Daher wird das click Event dynamisch für folgende Toggles "#zusatz-info .toggle" gesetzt.
//Das toggeln darf die dynamische Eventbindung aber erst übernehmen, wenn die Artikelauswahl einmal ausgeführt wurde (und der statische EventHanlder von re-lounge somit nicht mehr aktiv ist)
//durchgeführt werden. => daher diese Variable
let wurdeArtikelauswahlMindestensEinMalAusgefuehrt = false;

//Winco Item Ids
const $itemIdAnzeigen = $('input[name="item-id-anzeigen"]');
const $itemIdLinks = $("td.item-id a");
const $smTabelleGanter = $("#product-table div.priority-table.ganter");
const $smTabelleWinco = $("#product-table div.priority-table.winco");

if (window.location.hash !== "") {
	let hash = decodeURIComponent(window.location.hash);
	hash = hash.substr(1, hash.length - 1);
	updateArtikelauswahl(hash);
}

//Item Id Anzeige korrekt initialisieren
if (webCookie.values?.ItemIdAnzeigen === true) {
	// ob die Winco Tabelle angezeigt werden darf ist nun auch Normblattbahänig
	if ($itemIdAnzeigen.attr("data-winco-partnumber-anzeigen") === "True") {
		$itemIdAnzeigen.prop("checked", true);
		$smTabelleGanter.hide();
		$smTabelleWinco.show();
	} else {
		$smTabelleGanter.show();
		$smTabelleWinco.hide();
	}
}

//Normblatt-Ausführungen
$artikelauswahl.find('input[id^="norm"]').on("change", e => {
	let url = $(e.currentTarget).attr("value")!;

	if (environment.native) {
		url = "/native" + url;
	}

	window.location.href = url;
});

// §HACK 20.02.2025/LT <GKS-5673@31718> Für Inocon wird das 3D-Vorschau Modal manuell aufgemacht
$cadenas3DButtonWrapper.on("click", e => {
	e.preventDefault();

	$.fancybox.open([
		{
			src: $cadenas3DButton.attr("data-url")!,
			type: "iframe",
		},
	]);
});

$artikelMenge.on("keyup", onArtikelmengeChanged);
$artikelMenge.on("change", onArtikelmengeChanged);
$(".countup, .countdown").on("click", onArtikelmengeChanged);

async function onArtikelmengeChanged() {
	if ($artikelNr.attr("data-ist-artikel-vollstaendig") === "true") {
		await getArtikelpreisUndLagerverfuegbarkeit();
		setLagerverfuegbarkeitsFarbe(Number($artikelMenge.val()));
	}
}

async function getArtikelpreisUndLagerverfuegbarkeit() {
	var data = await $.ajax({
		url: apiEndpoints.artikelauswahlPreis,
		cache: false,
		headers: landKuerzelHeader,
		data: {
			artikelNrOhneEigentuemer: getArtikelNrOhneEigentuemer(),
			identityCulture: environment.identityCulture,
			deliveryCountry: artikelauswahlSettings.deliveryCountry,
			menge: $artikelMenge.val(),
			waehrungId: $artikelLocationData.attr("data-currency-id"),
			salesLocationId: $artikelLocationData.attr("data-sales-location-id"),
			authenticationTicket: getAuthenticationTicket(),
			lagerbestandAusblenden: false
		}
	});

	$artikelPreisInfo.html(data.preisInfo);
	$artikelZusatzInfo.html(data.zusatzInfo);
	$artikelLagerverfuegbarkeitInfo.html(data.lagerverfuegbarkeitInfo);
}

//Artikelauswahl-Eigenschaften (alle Elemente die überwacht werden müssen)
$artikelauswahl.on("change", ".artikelauswahl-eigenschaften :radio, .artikelauswahl-eigenschaften :submit, .artikelauswahl-eigenschaften :text", function() {
	if ($(this).attr("type") == "radio") {
		updateArtikelauswahl($(this).attr("value")!);
		return;
	}

	//Unterstützung für die Range-Eingabe (GN 990)
	let text = $artikelauswahl.find(":text").filter(`[name=${$(this).attr("name")}]`);
	let hiddenText = $artikelauswahl.find(":hidden").filter(`[name=${$(this).attr("name")}]`);

	let filter = $(hiddenText).attr("value")!;

	filter = filter.substring(0, filter.lastIndexOf("("));
	filter = `${filter}(${$(text).val()})`;

	updateArtikelauswahl(filter);
});

//Warenkorb hinzufügen
$artikelauswahl.find("#Warenkorb,#Anfragekorb").on("click", async e => {
	e.preventDefault();

	let data = await addToWarenkorb(getArtikelNrOhneEigentuemer(), $artikelMenge.val() as number, $(e.currentTarget).attr("id") as WarenkorbTyp);
	showNotification(getNotificationStatus(data.fehler), data.status);

	if (data.fehler) return;

	artikelauswahlClient.AktualisiereMengenAnzeige(data.warenkorbTyp, data.anzahlPositionen);

	if (data.warenkorbTyp == WarenkorbTyp.Warenkorb) {
		updateWarenkoerbeInfos();
	}

	// Dem GoogleAnalytics-DataLayer die Aktion bekannt geben
	// Für re-lounge reicht es hier aus, dass wir dem DataLayer die Artikelnummer bekannt geben.
	// Deren TagManager erledigt dann den Rest.
	dataLayerPush({ "ecomm_prodid": getArtikelNrOhneEigentuemer() });
});

//Cad-Download: Direkter Cadenas Request
// Achtung: enthält obsoleten code für step download
$cadDownloadForms.on("submit", e => {
	//Form-Post Request verhindern
	e.preventDefault();
	const $downloadForm = $(e.currentTarget);

	try {
		$downloadForm.find(":submit").attr("disabled", "disabled");

		$.ajax({
			type: "POST",
			url: $downloadForm.attr("action"),
			data: getCadDownloadFormData($downloadForm),
			success: (data) => {
				const $cadenasFormat = $downloadForm.find("#cadenasformat");

				if (data.ungueltigesCadenasFormat) {
					$cadenasFormat.addClass("is-invalid");
				} else {
					$cadenasFormat.removeClass("is-invalid");
				}

				//Schnell-Anmeldung verfällt nach jedem Download
				if (data.schnellAnmeldungDownload || data.schnellAnmeldungUngueltig) {
					if (webCookie.values) {
						webCookie.values.schnellAnmeldenEmail = null;
						webCookie.values.schnellAnmeldenId = null;
						saveWebCookie();
					}

					$cadAnmeldenForm.show();
					$cadSchnellAnmeldenForm.show();
					$cadSchnellAnmeldenForm.attr("data-schnell-angemeldet", "false");
					//Cad-Download wieder deaktivieren
					$downloadForm.find("select,:submit").attr("disabled", "disabled");
				}

				showNotification(getNotificationStatus(data.fehler), data.status, 10000);

				if (data.downloadCadFile) {
					cadZipDownload(data.downloadUrl);
				}
			},
			error: (_xmlHttpRequest, _textStatus, errorThrown) => showNotification(NotificationStyle.Error, errorThrown)
		});
	} catch (e) {
		throw e;
	} finally {
		$downloadForm.find(":submit").removeAttr("disabled");
	}
});

//Cad-Anmeldung: Die Anmeldung direkt per Ajax-Request
$cadAnmeldenForm.on("submit", (e) => {
	//Form-Post Request verhindern
	e.preventDefault();

	$.ajax({
		type: "POST",
		url: $cadAnmeldenForm.attr("action"),
		data: $cadAnmeldenForm.serialize(),
		success: (data) => {
			const emailCadLogin = getInputUndLabel($cadAnmeldenForm, "EmailCadAnmelden");
			const kennwortCadLogin = getInputUndLabel($cadAnmeldenForm, "KennwortCadAnmelden");

			if (data.anmeldungErfolgreich) {
				if ($cadAnmeldenForm.find("#AngemeldetBleibenNova").prop("checked")) {
					//Setzt das FormsAuthentication-Cookie
					//Achtung bei Änderungen auch den web.config-Eintrag authentication => forms => timeout berücksichtigen!
					setAuthenticationTicket(data.authenticationTicket, { expires: 30, path: "/" });
				} else {
					//Setzt das FormsAuthentication-Cookie (Session Cookie)
					setAuthenticationTicket(data.authenticationTicket, { path: "/" });
				}

				// Seite neu laden und die Steuerelemente korrekt nach dem Anmelde-Status anzuzeigen.
				location.reload();

				//Mein-Ganter-Info (Anmeldestatus; Top-Menü) aktualisieren
				$('[data-username="1"]').html(data.vollstaendigerName);
				$('[data-logged-in="1"]').show();
				$('[data-logged-out="1"]').hide();

				//Anmelde Varianten (Login, Quicklogin) aus dem Dom entfernen
				//(Abmelden erfolgt über einen kompletten request)
				//da sonst die Anmeldung bei einer erneuten Artikelauswahl wieder angezeigt würde
				$cadAnmeldenForm.remove();
				$cadSchnellAnmeldenForm.remove();

				//Cad-Download Deaktivierung entfernen
				$cadDownloadForm.find("select,:submit").removeAttr("disabled");

				//Als Favorit speichern einblenden
				$alsFavoritSpeichern.attr("data-angemeldet", "true");
				$alsFavoritSpeichern.show();
			} else {
				if (data.emailCadAnmeldenUngueltig) {
					emailCadLogin.label.addClass("is-invalid");
				} else {
					emailCadLogin.label.removeClass("is-invalid");
				}

				if (data.kennwortCadAnmeldenUngueltig) {
					kennwortCadLogin.label.addClass("is-invalid");
				} else {
					kennwortCadLogin.label.removeClass("is-invalid");
				}

				showNotification(NotificationStyle.Error, data.status);
			}

			kennwortCadLogin.input.val("");
		},
		error: (_xmlHttpRequest, _textStatus, errorThrown) => showNotification(NotificationStyle.Error, errorThrown)
	});
});

// Cad-Quicklogin
$cadSchnellAnmeldenForm.on("submit", (e) => {
	e.preventDefault();
	let emailCadSchnellAnmelden = getInputUndLabel($cadSchnellAnmeldenForm, "EmailCadSchnellAnmelden");
	let email = emailCadSchnellAnmelden.input.val();

	emailCadSchnellAnmelden.label.removeClass("is-invalid");

	$.ajax({
		type: "POST",
		url: apiEndpoints.cadSchnellAnmelden,
		data: {
			identityCulture: environment.identityCulture,
			email,
			captchaResponse: cadSchnellAnmeldenCaptcha?.getResponse(),
		},
		success: (data: ApiStatusResult) => {
			if (webCookie.values) {
				//Erfolgreiche Schnell-Anmeldung im Profilierungscookie speichern
				webCookie.values.schnellAnmeldenEmail = email;
				saveWebCookie();
			}
			//TODO Falls keine Cookies erlaub sind, darf hier nicht die Erfolgsmeldung kommen sondern ein Cookiefehler muss angezeigt werden

			//Anmelde Varianten (Login, Quicklogin) ausblenden
			$cadAnmeldenForm.hide();
			$cadSchnellAnmeldenForm.hide();
			$cadSchnellAnmeldenForm.attr("data-schnell-angemeldet", "true");

			//und deren Status und Eingaben zurücksetzen (da die Schnell-Anmeldung nach dem Download wieder eingeblendet werden)
			emailCadSchnellAnmelden.input.val("");
			cadSchnellAnmeldenCaptcha?.reset();

			//Cad-Download Deaktivierung entfernen
			$cadDownloadForm.find("select,:submit").removeAttr("disabled");

			//Anmeldebestätigung anzeigen
			showNotification(NotificationStyle.Success, data.status);
		},
		error: (request, _textStatus, errorThrown) => {
			let data = request.responseJSON as ApiStatusResult;

			if (request.status == StatusCodes.BAD_REQUEST) {
				emailCadSchnellAnmelden.label.addClass("is-invalid");

				showNotification(NotificationStyle.Error, data.status);
				return;
			}

			if (request.status == StatusCodes.UNAUTHORIZED) {
				cadSchnellAnmeldenCaptcha?.reset();

				showNotification(NotificationStyle.Error, data.status);
				return;
			}

			showNotification(NotificationStyle.Error, errorThrown);
		}
	});
});

// Cad-Anfrage: hier ist kein direkter Download möglich (Email an Ganter)
$cadAnfrageForm.on("submit", (e) => {
	e.preventDefault();
	let cadAnfrageEmail = getInputUndLabel($cadAnfrageForm, "EmailCadAnfrage");
	cadAnfrageEmail.label.removeClass("is-invalid");

	$.ajax({
		type: "POST",
		url: apiEndpoints.cadAnfragen,
		data: {
			identityCulture: environment.identityCulture,
			artikelnummer: $cadArtikelnummerFelder.val(),
			cadFormatTyp: $cadAnfrageForm.find("[name='CADFormatTyp']:checked").val(),
			email: cadAnfrageEmail.input.val(),
			captchaResponse: cadAnfrageCaptcha?.getResponse(),
		},
		success: (data: ApiStatusResult) => {
			cadAnfrageEmail.input.val("");
			cadAnfrageCaptcha?.reset();

			showNotification(NotificationStyle.Success, data.status);
		},
		error: (request, _textStatus, errorThrown) => {
			let data = request.responseJSON as ApiStatusResult;

			if (request.status == StatusCodes.BAD_REQUEST) {
				cadAnfrageEmail.label.addClass("is-invalid");

				showNotification(NotificationStyle.Error, data.status);
				return;
			}

			if (request.status == StatusCodes.UNAUTHORIZED) {
				cadAnfrageCaptcha?.reset();

				showNotification(NotificationStyle.Error, data.status);
				return;
			}

			showNotification(NotificationStyle.Error, errorThrown);
		}
	});
});

$alsFavoritSpeichern.on("click", () => {
	if ($alsFavoritSpeichern.attr("data-angemeldet") == "true") {
		$.ajax({
			url: $alsFavoritSpeichern.attr("data-favorit-angemeldet-url"),
			cache: false,
			data: {
				identityCulture: environment.identityCulture,
				authenticationTicket: getAuthenticationTicket(),
				artikelNr: getArtikelNrOhneEigentuemer(),
			},
			success: (data) => {
				showNotification(getNotificationStatus(data.fehler), data.status);
			},
			error: (_xmlHttpRequest, _textStatus, errorThrown) => showNotification(NotificationStyle.Error, errorThrown)
		});
	} else {
		let favoritUrl = $alsFavoritSpeichern.attr("data-favorit-nicht-angemeldet-url")!;
		favoritUrl = favoritUrl.replace("-nr-", getArtikelNrOhneEigentuemer());
		window.location.href = favoritUrl;
	}

	return false;
});

$alsMerklisteSpeichern.on("click", e => {
	e.preventDefault();

	$.ajax({
		url: $alsMerklisteSpeichern.attr("data-angemeldet-url"),
		cache: false,
		data: {
			identityCulture: environment.identityCulture,
			authenticationTicket: getAuthenticationTicket(),
			artikelNr: $artikelNr.attr("data-artikelnr-ohne-eigentuemer"),
			merklisteID: $artikelauswahl.find("#Merklisten option:selected").val(),
			menge: $artikelauswahl.find("#product-count").val()
		},
		success: (data) => {
			showNotification(getNotificationStatus(data.fehler), data.status);
		},
		error: (_xmlHttpRequest, _textStatus, errorThrown) => showNotification(NotificationStyle.Error, errorThrown)
	});
});

$alsMerklisteAnlegen.on("click", e => {
	e.preventDefault();

	if ($alsMerklisteAnlegen.attr("data-angemeldet") == "true") {
		window.location.href = $alsMerklisteAnlegen.attr("data-angemeldet-url")!;
	}
	else {
		let url = $alsMerklisteAnlegen.attr("data-nicht-angemeldet-url")!;
		url = url.replace("-nr-", $artikelNr.attr("data-artikelnr-ohne-eigentuemer")!);
		window.location.href = url;
	}

	return false;
});

//siehe Kommentar wurdeArtikelauswahlMindestensEinMalAusgefuehrt!!!
$artikelauswahl.on("click", "#zusatz-info .toggle", function() {
	if (wurdeArtikelauswahlMindestensEinMalAusgefuehrt === true) {
		// Change toggle state
		$(this).toggleClass("is-closed");
	}
});

//winco Item Ids ein und ausblenden
$itemIdAnzeigen.on("change", function() {
	const itemIdAnzeigen = $(this).prop("checked");

	$itemIdAnzeigen.prop("checked", itemIdAnzeigen);
	if (itemIdAnzeigen === true) {
		$smTabelleGanter.hide();
		$smTabelleWinco.show();
	} else {
		$smTabelleGanter.show();
		$smTabelleWinco.hide();
	}

	//Winco Id Einstellung im Cookie speichern
	if (webCookie.values) {
		webCookie.values.ItemIdAnzeigen = $itemIdAnzeigen.prop("checked");
		saveWebCookie();
	}
});

//Beim klicken auf die Winco Item ids soll die Artikelauswahl dementsprechend angepasst werden
$itemIdLinks.on("click", function() {
	const partNumber = $(this).text();

	$.ajax({
		url: apiEndpoints.artikelauswahl,
		cache: false,
		headers: landKuerzelHeader,
		data: {
			identityCulture: environment.identityCulture,
			deliveryCountry: artikelauswahlSettings.deliveryCountry,
			normblattGuid: artikelauswahlSettings.normblattGuid,
			partNumber: partNumber,
			waehrungId: $artikelLocationData.attr("data-currency-id"),
			salesLocationId: $artikelLocationData.attr("data-sales-location-id")
		},
		success: (data) => {
			onArtikelauswahlSuccess(data, data.filter, false);

			$("html,body").animate({ scrollTop: $("#product-dimensions").offset()!.top }, "fast");
		}
	});

	return false;
});

//Artikelauswahl
function updateArtikelauswahl(filter: string) {
	$.ajax({
		url: apiEndpoints.artikelauswahl,
		cache: false,
		headers: landKuerzelHeader,
		data: {
			normblattGuid: artikelauswahlSettings.normblattGuid,
			identityCulture: environment.identityCulture,
			deliveryCountry: artikelauswahlSettings.deliveryCountry,
			filter: filter,
			masseinheit: artikelauswahlSettings.masseinheit,
			menge: $artikelMenge.val(),
			waehrungId: $artikelLocationData.attr("data-currency-id"),
			salesLocationId: $artikelLocationData.attr("data-sales-location-id"),
			authenticationTicket: getAuthenticationTicket(),
		},
		success: (data) => {
			onArtikelauswahlSuccess(data, filter, false);
		}
	});
}

function onArtikelauswahlSuccess(data: ArtikelauswahlApiResponse, filter: string, artikelauswahlVia3DPreivew: boolean) {
	$artikelauswahlEigenschaften.html(data.artikelauswahl);
	$artikelauswahlEigenschaftenModal.html(data.artikelauswahlModal);

	artikelauswahlClient.SetArtikelauswahlArtikelnummer(data.artikelNr);

	if (!($cadenas3DButton === undefined || $cadenas3DButton === null || $cadenas3DButton.length === 0 || data.cadArtikelNr === null)) {
		const cadenas3dBaseUrl = $cadenas3DButton.attr("data-base-url")!;
		$cadenas3DButton.attr("data-url", cadenas3dBaseUrl.replace("{1}", encodeURIComponent(data.cadArtikelNr)));
		$cadenas3DButton.attr("data-artikelnr", data.cadArtikelNr);

		if (data.cadenasProjektpfad != null) {
			const cadenas3DUrl = $cadenas3DButton.attr("data-url")!;
			$cadenas3DButton.attr("data-url", cadenas3DUrl.replace("{0}", data.cadenasProjektpfad));
			$cadenas3DButton.attr("data-projektdatei", data.cadenasProjektpfad);
		}

		artikelauswahlSettings.cadDatenVorhanden = data.cadDownloadAnzeigen;
		$cadenas3DButton.toggle(data.cadDownloadAnzeigen);
		$("#product-3d-configurator").toggle(data.cadDownloadAnzeigen);
	}
	$artikelNr.attr("data-artikelnr-ohne-eigentuemer", data.artikelNrOhneEigentuemer);
	$microDataArtikelNr.attr("content", data.artikelNr);
	$artikelPreisInfo.html(data.preisInfo);
	$artikelZusatzInfo.html(data.zusatzInfo);
	$cadArtikelnummerFelder.val(data.artikelNrOhneEigentuemer);

	// SEO Schema.org/offer
	$("[itemprop='offers']")
		.find("[itemprop='price']")
		.prop("content", data.metaPreise?.Preis ?? "-");

	if (data.istArtikelVollstaendig) {
		artikelBestellen.show();
		artikelCad.show();
		$cadDownloadTitel.show();

		//Je nach Cad-Status Download bzw. Anfrage Option einblenden
		//die dazugehörigen Status-Elemente müssen nicht berücksichtigt werden
		//diese werden weiter ohben schon ausgeblendet.

		showStepDownload(data.stepDownloadAnzeigen);

		// Weitere Formate von Cadenas
		if (data.cadDownloadAnzeigen) {
			$cadDownloadForm.show();

			if ($cadSchnellAnmeldenForm.attr("data-schnell-angemeldet") == "false") {
				$cadAnmeldenForm.show();
				$cadSchnellAnmeldenForm.show();
			}

			if (!artikelauswahlVia3DPreivew) {
				konfigurator3DViewer.setArtikel({ projektdatei: data.cadenasProjektpfad, artikelnummer: data.artikelNr });
			}

			// Wenn ein Artikel keinen Preis hat, darf er nicht in den Warenkorb gelegt werden können (GKS-1887)
			if (data.artikelHatPreis) {
				$("#Warenkorb").show();
			} else {
				$("#Warenkorb").hide();
			}
		} else {
			konfigurator3DViewer.clear();
			$cadDownloadForm.hide();
			$cadAnmeldenForm.hide();
			$cadSchnellAnmeldenForm.hide();
		}

		// Anfrage-Form
		if (data.cadAnfrageAnzeigen) {
			$cadAnfrageTitel.show();
			$cadDownloadTitel.hide();
			$cadAnfrageForm.show();
		} else {
			$cadAnfrageTitel.hide();
			$cadAnfrageForm.hide();
		}

		$alsFavoritSpeichern.show();
		$artikelNr.attr("data-ist-artikel-vollstaendig", "true");
	} else {
		konfigurator3DViewer.clear();
		artikelBestellen.hide();
		artikelCad.hide();

		$alsFavoritSpeichern.hide();
		$artikelNr.attr("data-ist-artikel-vollstaendig", "false");
	}

	$artikelMenge.attr("data-lagerbestand", data.lagerbestand);
	$artikelMenge.trigger("change"); //Nicht besonders schön aber effektiv; der Lagerbestand wird auf die aktuell ausgewählte Menge geprüft.

	//Neuer Hash setzen ohne dabei Browser History eingräge zu produzieren.
	replaceHash(encodeURIComponent(filter));

	//siehe Kommentar wurdeArtikelauswahlMindestensEinMalAusgefuehrt!!!
	wurdeArtikelauswahlMindestensEinMalAusgefuehrt = true;

	artikelauswahlClient.SetArtikelauswahlNormblattBild(data);
}

function getFormDataAsJsObject($form: JQuery<HTMLElement>) {
	const data: { [key: string]: any; } = {};
	const formData = $form.serializeArray();

	//Lößung von stackoverflow
	//http://stackoverflow.com/a/1186309
	//aber leicht abgewandelt n-Formelemente mit dem gleichen Namen werden kommasepariert
	$.each(formData, function() {
		if (data[this.name] !== undefined) {
			//if (!data[this.name].push) {
			//    data[this.name] = [data[this.name]];
			//}
			//data[this.name].push(this.value || "");
			data[this.name] = `${data[this.name]},${this.value || ""}`;
		} else {
			data[this.name] = this.value || "";
		}
	});

	return data;
}

// Für den Cad-Download muss unbedingt das Authentifizierungs-Cookie mit übergeben werden
function getCadDownloadFormData($downloadForm: JQuery<HTMLElement>) {
	const formData = getFormDataAsJsObject($downloadForm);

	if ($downloadForm.attr("id") === "cad-freier-download") {
		formData["freierDownload"] = true;
	}

	// Anmeldung
	formData["authenticationTicket"] = getAuthenticationTicket();
	if (webCookie.values) {
		// Schnell Anmeldung
		formData["schnellAnmeldenEmail"] = webCookie.values.schnellAnmeldenEmail;
		formData["schnellAnmeldenId"] = webCookie.values.schnellAnmeldenId;
	}

	return formData;
}

// 20.09.17/BG
function cadZipDownload(uri: string) {
	window.location.href = uri;
}

function toggleEmail(alsEmail: boolean) {
	$artikelauswahl.find("[name='angemeldetAlsEmail']").each(function() {
		$(this).val(alsEmail.toString());
	});
}

$cadFreierDownloadButton.on("click", () => {
	toggleEmail(false);
});

$cadStdButton.on("click", () => {
	toggleEmail(false);
});

$cadStdButton.on("click", () => {
	toggleEmail(false);
});

$cadAngemeldetAlsEmailButton.on("click", () => {
	toggleEmail(true);
});

// Vorschau im 3D-Konfigurator erst laden, wenn der User drauf klickt.
$("#product-3d-configurator").on("click", async () => {
	await konfigurator3DViewer.load();
});

$("#3d-configurator-weiter").on("click", async () => {
	$("html, body").animate({
		scrollTop: $("#product-dimensions").offset()?.top
	});
});

function updateArtikelauswahlVia3DPreview(artikelNr: string) {
	$.ajax({
		url: apiEndpoints.artikelauswahl,
		cache: false,
		headers: landKuerzelHeader,
		data: {
			normblattGuid: artikelauswahlSettings.normblattGuid,
			identityCulture: environment.identityCulture,
			deliveryCountry: artikelauswahlSettings.deliveryCountry,
			masseinheit: artikelauswahlSettings.masseinheit,
			menge: $artikelMenge.val(),
			waehrungId: $artikelLocationData.attr("data-currency-id"),
			salesLocationId: $artikelLocationData.attr("data-sales-location-id"),
			authenticationTicket: getAuthenticationTicket(),
			artikelauswahlVia3dPreview: true,
			artikelNr3dPreview: artikelNr
		},
		success: (data) => {
			if (data !== null) {
				onArtikelauswahlSuccess(data, data.filter, true);
			}
		}
	});
}

$(".cta--print").on("click", () => {
	window.print();
	return false;
});

$("a[data-cookiebot-renew]").on("click", () => {
	Cookiebot.renew();
	return false;
});
